export default __webpack_public_path__ + "static/media/235.d4cb48e6.png";